import { useCallback } from 'react';

import { KEY_AUTH_USER, User } from '@/entities';
import { useStorage } from '@/hooks//useStorage';

import { useCurrentCompanyId } from './useCurrentCompanyId';

export const useAuth = () => {
  const { getItem } = useStorage();
  const companyId = useCurrentCompanyId();

  const getAuthUser = useCallback((): User | null => {
    const rawUser = getItem(KEY_AUTH_USER);
    if (rawUser) {
      return JSON.parse(rawUser) as User;
    }
    return null;
  }, [getItem]);

  const isAuthenticated = useCallback((): boolean => {
    const authUser = getAuthUser();
    return !!authUser && !!companyId;
  }, [getAuthUser, companyId]);

  return {
    isAuthenticated,
    getAuthUser,
  };
};
